import gql from "graphql-tag"

export const CMS_INTEGRATIONS_QUERY = gql`
  query cmsIntegrationsForSite($siteId: UUID!, $connected: Boolean) {
    cmsIntegrationsForSite(siteId: $siteId, connected: $connected) {
      id
      name
      formattedName
      logoUrl
      details
      description
      connected
      features {
        envVars
        webhooks
        extension
      }
    }
  }
`
